import dayjs from "dayjs";
import React, { useState } from "react";
import { Link } from "react-router-dom";
import { formatCurrency, getLink, toast } from "../../../../utils/helpers";

const FacturasGroup = ({
	factura,
	toggleDeleteModal,
	openValidarFacturaModal,
    generarProximaFactura
}) => {
	const [showFacturas, setShowFacturas] = useState(false);

	const toggleFacturas = () => {
		setShowFacturas((state) => !state);
	};

	const validate = (facturaRecurrente) => {
		const noValidateFacturas = factura?.facturas?.filter((facturaRecurrente) => facturaRecurrente.recurrencia_id &&
			facturaRecurrente.validada === "no" && facturaRecurrente.estado === "pendiente") ?? [];
		const nextFacturaTovalidate = noValidateFacturas.length ? noValidateFacturas[0].id : -1;

		if (facturaRecurrente.id === nextFacturaTovalidate) {
			openValidarFacturaModal(facturaRecurrente);
		} else {
			toast("Las Facturas se deben validar en orden de emisión.", "error");
		}
	};


	return (
		<div
			className="descuento-item"
			id={`di-${factura.id}`}
			key={factura.id}
		>
			<div
				className="descuento-row descuento-info"
				onClick={() => toggleFacturas()}
			>
				<div>
					<strong>
						<Link
							to={getLink(
								`/contactos/${factura.factura?.cliente?.id}/transacciones`
							)}
							onClick={() => {
								localStorage.setItem(
									"contacto",
									JSON.stringify(factura.factura?.cliente)
								);
							}}
						>
							{factura.factura?.cliente?.codigo} - {factura.factura?.cliente?.nombre}
						</Link>
					</strong>
				</div>
				<div>
					<small>
						<strong>Estado:</strong>{" "}
						{factura.status === "activo" ? (
							<span className="badge badge-success p-2">Activo</span>
						) : (
							<span className="badge badge-secondary p-2">Inactivo</span>
						)}
					</small>
					<small>
						<strong>Plazo de pago:</strong> {factura.frecuencia}
					</small>
					<small>
						<strong>Numeración:</strong>{" "}
						{factura.factura?.numeracion?.nombre}
					</small>
				</div>
				<div>
					<div>
						<strong>
							{formatCurrency(factura.factura?.total)}
						</strong>
					</div>
					# Ocurrencias: {factura.ocurrencias > 0 ? factura.ocurrencias : "∞"}
				</div>
				<div>{dayjs(factura.fecha_inicio).format("DD/MM/YYYY")}</div>
				<div>
					{/* {completadas.length > 0 && <div>
                        <strong>Último:{' '}</strong>
                        <div>
                            {ultimaCuota}
                        </div>
                    </div>} */}
					{factura.facturas?.length > 0 && (
						<div>
							<div>
								<strong>Próximo: </strong>
								{factura.siguiente ? dayjs(factura.siguiente).format("DD/MM/YYYY") : ''}
							</div>
							<strong>Final:</strong>{" "}
                            {factura.ocurrencias > 0 ? dayjs(factura.final).format("DD/MM/YYYY") : "Nunca termina"}
						</div>
					)}
					{factura.frecuencia === "Unico" && (
						<div>
							<strong>Fecha: </strong>
							<div>
								{dayjs(factura.created_at).format("DD/MM/YYYY")}
							</div>
						</div>
					)}
				</div>
				<div>
                    <div className="table-data-feature">
                        <div className="dropdown">
                            <button className="au-btn au-btn-icon au-btn-filter">
                                Acciones
                            </button>
                            <div
                                style={{
                                    left: "auto",
                                    right: "0",
                                }}
                                className="dropdown-menu"
                            >
                                {factura.ocurrencias < 0 || factura.facturas.length < factura.ocurrencias ? (
                                    <button
                                        onClick={ (e) => generarProximaFactura(e, factura.id)}
                                        type="button"
                                        className="dropdown-item"
                                        title="Generar próxima ocurrencia"
                                    >
                                        Generar Próxima Ocurrencia
                                    </button>
                                ) : ""}
                                <Link
                                    to={getLink(
                                        `/ingresos/facturas-recurrentes/${factura.factura?.id}/edit`
                                    )}
                                    target="_blank"
                                    className="dropdown-item"
                                    title="Editar"
                                >
                                    Editar
                                </Link>
                                <button
                                    className="dropdown-item"
                                    onClick={() =>
                                        toggleDeleteModal(factura)
                                    }
                                >
                                    Eliminar
                                </button>
                            </div>
                        </div>
                    </div>
				</div>
			</div>

			{factura.facturas?.length > 0 && (
				<div
					className={`descuento-cuotas ${showFacturas ? "show" : ""}`}
				>
					<table className="table">
						<thead>
							<tr>
								<th>Numeración</th>
								<th>Monto</th>
								<th>Fecha</th>
								<th>Estado</th>
								<th></th>
							</tr>
						</thead>
						<tbody>
							{factura.facturas.map(
								(facturaRecurrente, index) => (
									<tr
										key={facturaRecurrente.id}
										className={`cuota ${facturaRecurrente.estado}`}
									>
										<td>{facturaRecurrente.numero_comprobante}</td>
										<td>{formatCurrency(facturaRecurrente.total)}</td>
										<td>
											<div>
												<strong>Emisión: </strong>
												{dayjs(
													facturaRecurrente.fecha_emision ?? facturaRecurrente.fecha
												).format("DD/MM/YYYY")}
											</div>
											<div>
												{facturaRecurrente.estado ===
													"pagada" && (
													<>
														<strong>
															Pagada:{" "}
														</strong>
														{dayjs(
															facturaRecurrente.fecha
														).format("DD/MM/YYYY")}
													</>
												)}
											</div>
										</td>
										<td className="cuota__estado">
											{facturaRecurrente.estado === "activo" ? (
												<span className="badge badge-success p-2">Activo</span>
											) : (
												<span className="badge badge-secondary p-2">Inactivo</span>
											)}
										</td>
										<td>
											{!facturaRecurrente.deleted_at && (
												<div className="table-data-feature">
													{facturaRecurrente.recurrencia_id &&
													facturaRecurrente.validada === "no" &&
													facturaRecurrente.estado === "pendiente" ?
													<span className="badge badge-danger mx-2 p-2">No Validada</span> :
													<span className="badge badge-success mx-2 p-2">Validada</span>
													}
													<div className="dropdown">
														<button className="au-btn au-btn-icon au-btn-filter">
															Acciones
														</button>
														<div
															style={{
																left: "auto",
																right: "0",
															}}
															className="dropdown-menu"
														>
															{facturaRecurrente.recurrencia_id &&
															facturaRecurrente.validada ===
																"no" && facturaRecurrente.estado === "pendiente" ? (
																<>
                                                                    <button
                                                                        className="dropdown-item"
                                                                        onClick={() =>
                                                                            validate(
                                                                                facturaRecurrente
                                                                            )
                                                                        }
                                                                    >
                                                                        Validar
                                                                    </button>
                                                                    <Link
                                                                        to={getLink(
                                                                            `/ingresos/facturas/${facturaRecurrente.id}/edit`
                                                                        )}
                                                                        target="_blank"
                                                                        className="dropdown-item"
                                                                        title="Editar"
                                                                    >
                                                                        Editar
                                                                    </Link>
                                                                </>
															) : (
																<>
																	{/* {facturaRecurrente.estado ===
																		"pendiente" && (
																		<button
																			className="dropdown-item"
																			onClick={() =>
																				checkOpenPagarModal(
																					facturaRecurrente,
																					index
																				)
																			}
																		>
																			Pagar
																		</button>
																	)} */}
																	<Link
																		to={getLink(
																			`/imprimir/facturas/${facturaRecurrente.id}`
																		)}
																		target="_blank"
																		className="dropdown-item"
																		title="Impresión normal"
																	>
																		Impresión
																	</Link>
																</>
															)}
														</div>
													</div>
												</div>
											)}
										</td>
									</tr>
								)
							)}
						</tbody>
					</table>
				</div>
			)}
		</div>
	);
};

export default FacturasGroup;
